const RushDelivery = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]" />
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          <div className="flex flex-col justify-center">
            <h1 className="font-bold text-3xl text-[#373737]">Rush Delivery</h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              The chartered air cargo service allows TCS to assuredly respond to
              critically time-bound air cargo requests. Being a CGSA not only
              helps us to remain ahead of global air freight trends and real
              time pressure points, it also empowers us to get our customers’
              time-critical shipments in the air by quickly finding the nearest
              available aircraft taking off.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center">
            <img
              src="/aviation/image-4.jpg"
              alt=""
              className="max-w-[45rem] h-[30vh]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default RushDelivery;
